import { u as useTitleStyles } from '../Body-3jUYBH5W.js';
export { B as Body, F as Footer, H as Header, T as default } from '../Body-3jUYBH5W.js';
import classNames from 'classnames';
import { T as Tooltip } from '../Tooltip-mQqB3TNx.js';
import { j as jsxRuntimeExports } from '../jsx-runtime-KJzvSKZ_.js';

var PaperTitleType = /*#__PURE__*/function (PaperTitleType) {
  PaperTitleType["Basic"] = "basic";
  PaperTitleType["Circle"] = "circle";
  return PaperTitleType;
}({});

// @ts-nocheck
function PaperTitle(_ref) {
  var title = _ref.title,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? PaperTitleType.Circle : _ref$type,
    _ref$withTooltip = _ref.withTooltip,
    withTooltip = _ref$withTooltip === void 0 ? false : _ref$withTooltip,
    tooltipText = _ref.tooltipText,
    className = _ref.className;
  var styles = useTitleStyles({
    type: type
  });
  var content = /*#__PURE__*/jsxRuntimeExports.jsx("strong", {
    className: classNames(styles.root, className),
    children: title
  });
  if (withTooltip) {
    return /*#__PURE__*/jsxRuntimeExports.jsx(Tooltip, {
      overlay: tooltipText || title,
      children: content
    });
  }
  return content;
}

export { PaperTitleType, PaperTitle as Title };
//# sourceMappingURL=index.js.map
